import "../App.css";
import { useEffect, useState } from "react";
import {
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@material-ui/core";
import { useParams } from "react-router-dom";
import logo from "../assets/logo.png";
import { ArrowForward } from "@material-ui/icons";
import VideoComponent from "../VideoComponent/VideoComponent";
import { Helmet } from "react-helmet";
import data from "../data.json";
// Import the functions you need from the SDKs you need
import firebase from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import "firebase/firestore";
import fill from "../assets/fill.mp4";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAOB6Y6H3z3c-EXz66hEfiV6wbcUBL5z-Y",
  authDomain: "c-and-d-iv.firebaseapp.com",
  projectId: "c-and-d-iv",
  storageBucket: "c-and-d-iv.appspot.com",
  messagingSenderId: "993254260935",
  appId: "1:993254260935:web:42daa6b06a79cfd53afee2",
  measurementId: "G-R25QN3RMS8",
};

function HomePage() {
  const { id } = useParams();
  const [video, setVideo] = useState({});
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [member, setMember] = useState();

  let firebaseApp;
  // Initialize Firebase
  if (!firebase.apps.length) {
    firebaseApp = firebase.initializeApp(firebaseConfig);
  } else {
    firebaseApp = firebase.app(); // if already initialized, use that one
  }
  // const analytics = getAnalytics(app);
  const db = firebaseApp.firestore();

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      const formData = new FormData(e.target);
      const email = formData.get("email");
      console.log(email);
      if (ValidateEmail(email)) {
        setMessage("");
        setLoading(true);
        const emailDoc = await db
          .collection("savehearts_video")
          .doc(email)
          .get();
        let emailData = emailDoc.data();
        if (!emailData) emailData = { entries: [] };
        emailData.entries = [...emailData.entries, Date.now()];
        db.collection("savehearts_video").doc(email).set(emailData);
        setMember(email);
        setVerified(true);
        setLoading(false);
      } else {
        setMessage("Please enter a valid email.");
      }
    } catch (error) {
      console.log("onSubmit Error", error);
    }
    return false;
  };
  function ValidateEmail(mail) {
    console.log(mail);
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }
  useEffect(() => {
    const getVideo = async () => {
      try {
        data.url = fill;
        setVideo(data);
        setVerified(!data.private);
      } catch (error) {
        console.log("ERROR", error);
      }
    };
    getVideo();
  }, [id]);

  return (
    <div
      className="App"
      style={{
        backgroundImage: `url(${
          verified ? video.background_image : video.poster
        })`,
      }}
    >
      <img className="logo" src={logo} alt="logo" />
      {(verified && <VideoComponent data={video} member={member} />) || (
        <div className="select-lang-page">
          {(!video.uri && loading && <CircularProgress />) || (
            <>
              <Helmet>
                <title>{video.name}</title>
              </Helmet>
              <div className="form">
                <h1
                  className="big-title "
                  dangerouslySetInnerHTML={{ __html: video.title }}
                ></h1>
                <div className="language-selector">
                  {video.private && (
                    <form onSubmit={onSubmit}>
                      <InputLabel>
                        To Watch The Video Please Enter Your Email.
                      </InputLabel>
                      <FormControl fullWidth margin="normal">
                        <OutlinedInput
                          disabled={loading}
                          required
                          variant="outlined"
                          name="email"
                          type="email"
                          error={message !== ""}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton type="submit" disabled={loading}>
                                {(loading && (
                                  <CircularProgress
                                    color="secondary"
                                    size="1rem"
                                  />
                                )) || <ArrowForward />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        <FormHelperText>{message}</FormHelperText>
                      </FormControl>
                    </form>
                  )}
                  {/* <p>Choose Language</p>
              <Button href="/arabic">
                <img src={arIcon} alt="Arabic" />
              </Button>
              <Button href="/english">
                <img src={enIcon} alt="English" />
              </Button> */}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default HomePage;
